import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';

import metadata from './OperationsServicesComponent.metadata.json5';
import styles from '../../../pages/Commercial/CommercialPage.module.scss';
import InternalClassificationofOperationsComponent from "../subcomponent/InternalClassificationofOperations/InternalClassificationofOperationsComponent";


function OperationsServicesComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('ProductandcoveragesselectionComponent');
    const modelVM = _.get(submissionVM, pathUpdated)

    modelVM.value.isValidationReq = true


    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        InternalClassificationofOperationsComponent: {
            data: modelVM.operationInternalClaffics,
            updateWizardData,
            submissionVM,
            InternalClassificationofOperationsPath: `${pathUpdated}.operationInternalClaffics`

        },
        aretheanyothopenotaboFie: {
            defaultValue: false
        },
        ifothpledesFie: {
            visible: !_.isUndefined(modelVM.aretheanyothopenotaboFie.value) && modelVM.aretheanyothopenotaboFie.value
        },
        heaFieContainer: {
            visible: !_.isUndefined(modelVM.heaFie.value) && modelVM.heaFie.value
        },
        tecFieContainer: {
            visible: !_.isUndefined(modelVM.tecFie.value) && modelVM.tecFie.value
        },
        salFieContainer: {
            visible: !_.isUndefined(modelVM.salFie.value) && modelVM.salFie.value
        },
        serProFieContainer: {
            visible: !_.isUndefined(modelVM.serProFie.value) && modelVM.serProFie.value
        },
        othIndFieContainer: {
            visible: !_.isUndefined(modelVM.othIndFie.value) && modelVM.othIndFie.value
        }
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            InternalClassificationofOperationsComponent
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

OperationsServicesComponent.propTypes = wizardProps;
export default withRouter(OperationsServicesComponent);
